import {
  SizeGuideSection
} from "../size-guide-section"

const tableData = {
  title: "Men's Coverall & Snow Pants",
  headers: [
    [
      {
        content: "Men's Coverall & Snow Pants",
        colSpan: 6
      },
    ],
    [
      {
        content: "Size",
        rowSpan: 2 
      },
      {
        content: "Waist(In)",
        rowSpan: 2
      },
      {
        content: "Hipline(In)",
        rowSpan: 2
      },
      {
        content: "Inseam", 
        colSpan: 3 
      },
    ],
    [
      {
        content: "Short(In)" 
      },
      {
        content: "Regular(In)" 
      },
      {
        content: "Long(In)" 
      },
    ],
  ],
  data: [
    [
      {
        content: "S" 
      },
      {
        content: "28-30" 
      },
      {
        content: "34-36" 
      },
      {
        content: "" 
      },
      {
        content: "32" 
      },
      {
        content: "" 
      },
    ],
    [
      {
        content: "M"
      },
      {
        content: "32-34" 
      },
      {
        content: "38-40" 
      },
      {
        content: "30" 
      },
      {
        content: "32" 
      },
      {
        content: "34" 
      },
    ],
    [
      {
        content: "L"
      },
      {
        content: "36-38" 
      },
      {
        content: "42-44" 
      },
      {
        content: "30" 
      },
      {
        content: "32" 
      },
      {
        content: "34" 
      },
    ],
    [
      {
        content: "XL"
      },
      {
        content: "40-42" 
      },
      {
        content: "46-48" 
      },
      {
        content: "30" 
      },
      {
        content: "32" 
      },
      {
        content: "34" 
      },
    ],
    [
      {
        content: "XXL"
      },
      {
        content: "44-46" 
      },
      {
        content: "50-52" 
      },
      {
        content: "30" 
      },
      {
        content: "32" 
      },
      {
        content: "34" 
      },
    ],
    [
      {
        content: "3XL"
      },
      {
        content: "48-50" 
      },
      {
        content: "54-56" 
      },
      {
        content: "" 
      },
      {
        content: "32" 
      },
      {
        content: "" 
      },
    ],
  ],
}

export const CoverallSnowPants = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Coverall & Snow Pants'
    tableData={tableData}
    className={className}
  />
}

